<template>
  <div class="base-empty">
    <div class="base-empty__img">
      <img class="w-100" src="../../assets/img/empty-icon.svg" />
    </div>
    <div class="base-empty__title">
      <slot name="title">{{ $t(title) }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseEmpty',
  props: {
    /**
     * 內容標題
     */
    title: {
      type: String,
      default: 'common.noData',
    },
  },
};
</script>

<style lang="sass" scoped>
.base-empty
  &__title
    margin-top: 16px
    margin-bottom: 16px
    font-size: 1rem
    font-weight: 600
    color: #BDBDBD

  &__img
    max-width: 72px
    margin-top: auto
    margin-bottom: auto
</style>
